export const contactsData = {
    email: 'yashdesai281@gmail.com',
    phone: '9313100630',
    address: 'surat gujarat,india ',

    sheetAPI: ''
}